export const isUserPermitted = (allowForRoles = [], currentRole) => {
  const isPermitted = allowForRoles.some((res) => res === currentRole);
  return isPermitted;
};
